import { PaginatedColumn } from '../types/app';

export const PATHS_TABLE_COLUMNS: PaginatedColumn[] = [
  {
    label: 'Fecha inicio',
    key: 'startDate',
  },
  {
    label: 'Fecha fin',
    key: 'endDate',
  },
  {
    label: 'Información',
    key: 'info',
  },
  {
    label: 'Acciones',
    key: 'actions',
    centered: true,
    maxWidth: 100,
  },
];

export const PATHS_BY_GROUP_TABLE_COLUMNS: PaginatedColumn[] = [
  {
    label: 'Ident',
    key: 'ident',
  },
  {
    label: 'Etiqueta',
    key: 'label',
  },
  {
    label: 'Fecha inicio',
    key: 'startDate',
  },
  {
    label: 'Fecha fin',
    key: 'endDate',
  },
  {
    label: 'Información',
    key: 'info',
  },
  {
    label: 'Acciones',
    key: 'actions',
    centered: true,
    maxWidth: 100,
  },
];
